
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/pages",
      function () {
        return require("private-next-pages/admin/pages/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/pages"])
      });
    }
  